<p-accordionTab #notifications>
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full pt-2 -mb-2">
			<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{'NOTIFICATIONS_EMAIL' | translate }}</span></div>
		</div>
	</ng-template>
	<!-- TODO SPINNERRRR-->
	<div class="flex align-items-center justify-content-center w-full pb-4 mb-4" *ngIf="loading">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<form [formGroup]="emailConfigsForm" *ngIf="!isMTMAConnect()">
		<div class="grid pt-4" [class]="onExtendedMobile() ? '' : 'pl-6'">
			<div class="col-12" *ngIf="supportInfo()">
				<div class="flex align-items-center"
					[class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
					<p-checkbox formControlName="info" [binary]="true" value="true"
						(onChange)="setInfo($event.checked)"></p-checkbox>
					<span class="pi cm-check ml-3 mr-2"></span>{{ 'NTF_INFO' | translate }}
				</div>
			</div>
			<div class="col-12" *ngIf="supportWarning()">
				<div class="flex align-items-center"
					[class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
					<p-checkbox formControlName="warning" [binary]="true" value="true"
						(onChange)="setWarn($event.checked)"></p-checkbox>
					<span class="pi cm-alert ml-3 mr-2"></span>{{ 'NTF_WARNING' | translate }}
				</div>
			</div>
			<div class="col-12" *ngIf="supportError()">
				<div class="flex align-items-center"
					[class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
					<p-checkbox formControlName="error" [binary]="true" value="true"
						(onChange)="setErr($event.checked)"></p-checkbox>
					<span class="pi cm-error-1 ml-3 mr-2"></span>{{ 'NTF_ERROR' | translate }}
				</div>
			</div>
		</div>
	</form>

	<form [formGroup]="emailConfigsForm" *ngIf="isMTMAConnect()">
		<div class="grid pt-4" [class]="onExtendedMobile() ? '' : 'pl-6'">
			<div class="col-12">
				<div class="flex align-items-center"
					[class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
					<p-checkbox formControlName="info" [binary]="true" value="true"
						(onChange)="setInfo($event.checked)"></p-checkbox>
					<span class="pi cm-check ml-3 mr-2"></span>{{ 'INFO_ENTRIES_STATE' | translate }}
				</div>
			</div>
		</div>
	</form>
</p-accordionTab>